import { action, observable, computed } from "mobx";
import StringUtil from "utils/StringUtil";

import TbComFileDetailEntity from "./TbComFileDetailEntity";

/**
 * 공통 - 파일 상세
 */
export default class TbComFileDetail extends TbComFileDetailEntity {
  @observable protected registPsnNm?: string;

  public getRegistPsnNm() {
    return this.registPsnNm;
  }

  @action
  public setRegistPsnNm(registPsnNm: string) {
    this.registPsnNm = registPsnNm;
  }

  public getFormattedFileSize() {
	if ( this.fileSize !== undefined) {
		return StringUtil.formatNumber(String(this.fileSize));	
	} else {
		return '';
	}	
  }

  @computed
  public get mimeType() {
    let mineType = "";
    switch (this.fileExtsn?.toLowerCase()) {
      case "pdf":
        mineType = "application/pdf";
        break;
      case "ppt":
        mineType = "application/vnd.ms-powerpoint";
        break;
      case "pptx":
        mineType = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        break;
      case "doc":
        mineType = "application/msword";
        break;
      case "docx":
        mineType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        break;
      case "xls":
        mineType = "application/vnd.ms-excel";
        break;
      case "xlsx":
        mineType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        break;
      case "gz":
      case "zip":
        mineType = "application/zip";
        break;
      case "7z":
        mineType = "application/x-7z-compressed";
        break;
      case "tar":
        mineType = "application/x-tar";
        break;
      case "rar":
        mineType = "application/vnd.rar";
        break;
      default:
        mineType = "application/octet-stream"
        break;
    }
    return mineType;
  }
}
